import { AxiosError } from "axios";
import { UseQueryOptions, useQuery } from "react-query";

import { IGetTagQueryParameters, ITag, Route } from "@edgetier/watchtower-types";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Get all tags and sort them alphabetically.
 * @returns    Tags sorted by name.
 */
export const getTags = async (url: string, parameters: IGetTagQueryParameters) => {
    const tags = await getAllPaginatedItems<ITag>(url, { params: parameters });
    return tags.sort((one, two) => one.tag.localeCompare(two.tag));
};

/**
 * Get all tags. By default these are cached for a long time as they will very rarely change.
 * @returns React Query result.
 */
const useTags = <T = ITag[]>(
    parameters: IGetTagQueryParameters & { tagGroupId?: string } = {},
    configuration: UseQueryOptions<ITag[], AxiosError<void>, T> = {}
) => {
    const url = Route.Tags;
    return useQuery<ITag[], AxiosError<void>, T>([url, parameters], () => getTags(url, parameters), {
        cacheTime: Infinity,
        staleTime: Infinity,
        ...configuration,
    });
};

export default useTags;
